/*@ngInject*/
const MarkSubmissionLostRepository = function (baseRepository, notificationConstant) {

    angular.extend(this, baseRepository);

    this.markAsLost = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/markAsLostWithForm',
            config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    };

    this.createMarkAsLostForm = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/markAsLostForm',
            config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

        return this.post(url, {}, config);
    }

    this.deleteMarkAsLostForm = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/markAsLostForm';

        return this.delete(url);
    }
};

angular.module('gw-um-submission')
    .service('markSubmissionLostRepository', MarkSubmissionLostRepository);
